// Warning: This file is generated by the `plugins-updater` script.
import {
AclImg,
AcmeImg,
AiAzureContentSafetyImg,
AiPromptDecoratorImg,
AiPromptGuardImg,
AiPromptTemplateImg,
AiProxyImg,
AiRateLimitingAdvancedImg,
AiRequestTransformerImg,
AiResponseTransformerImg,
AppDynamicsImg,
ApplicationRegistrationImg,
AwsLambdaImg,
AzureFunctionsImg,
BasicAuthImg,
BotDetectionImg,
CanaryImg,
CorrelationIdImg,
CorsImg,
DatadogImg,
DegraphqlImg,
ExitTransformerImg,
FileLogImg,
ForwardProxyImg,
GraphqlProxyCacheAdvancedImg,
GraphqlRateLimitingAdvancedImg,
GrpcGatewayImg,
GrpcWebImg,
HmacAuthImg,
HttpLogImg,
ImpAppsecConnectorImg,
IpRestrictionImg,
JqImg,
JweDecryptImg,
JwtImg,
JwtSignerImg,
KafkaLogImg,
KafkaUpstreamImg,
KeyAuthEncImg,
KeyAuthImg,
LdapAuthAdvancedImg,
LdapAuthImg,
LogglyImg,
MockingImg,
MtlsAuthImg,
OasValidationImg,
Oauth2Img,
Oauth2IntrospectionImg,
OktaImg,
OpaImg,
OpenidConnectImg,
OpentelemetryImg,
OpenwhiskImg,
PostFunctionImg,
PreFunctionImg,
PrometheusImg,
ProxyCacheAdvancedImg,
ProxyCacheImg,
RateLimitingAdvancedImg,
RateLimitingImg,
RequestSizeLimitingImg,
RequestTerminationImg,
RequestTransformerAdvancedImg,
RequestTransformerImg,
RequestValidatorImg,
ResponseRatelimitingImg,
ResponseTransformerAdvancedImg,
ResponseTransformerImg,
RouteByHeaderImg,
RouteTransformerAdvancedImg,
SamlImg,
SessionImg,
StatsdAdvancedImg,
StatsdImg,
SyslogImg,
TcpLogImg,
TlsHandshakeModifierImg,
TlsMetadataHeadersImg,
UdpLogImg,
UpstreamTimeoutImg,
VaultAuthImg,
WebsocketSizeLimitImg,
WebsocketValidatorImg,
XmlThreatProtectionImg,
ZipkinImg
} from './images';

export const PluginsInfoData = {
    categories: [
        {
            category: "AI",
            plugins: [
                {
                    name: "AI Proxy",
                    description: "Call supported Large Language Model vendors and models through Kong Gateway, using mediated data formats and authentication",
                    image: AiProxyImg,
                    slug: "ai-proxy",
                    tags: [
                        "OSS"
                    ]
                },
                {
                    name: "AI Azure Content Safety",
                    description: "Use Azure Cognitive Services (Content Safety) to check and audit AI Proxy plugin messages before proxying them to an upstream LLM",
                    image: AiAzureContentSafetyImg,
                    slug: "ai-azure-content-safety",
                    tags: [
                        "KONNECT PAID",
                        "ENTERPRISE"
                    ]
                },
                {
                    name: "AI Prompt Decorator",
                    description: "Prepend or append an array of llm/v1/chat messages to a user's chat history",
                    image: AiPromptDecoratorImg,
                    slug: "ai-prompt-decorator",
                    tags: [
                        "OSS"
                    ]
                },
                {
                    name: "AI Prompt Guard",
                    description: "Check llm/v1/chat or llm/v1/completions requests against a list of allowed or denied expressions",
                    image: AiPromptGuardImg,
                    slug: "ai-prompt-guard",
                    tags: [
                        "OSS"
                    ]
                },
                {
                    name: "AI Prompt Template",
                    description: "Provide fill-in-the-blank AI prompts to users",
                    image: AiPromptTemplateImg,
                    slug: "ai-prompt-template",
                    tags: [
                        "OSS"
                    ]
                },
                {
                    name: "AI Rate Limiting Advanced",
                    description: "Provide rate limiting for AI providers defined in the AI plugins",
                    image: AiRateLimitingAdvancedImg,
                    slug: "ai-rate-limiting-advanced",
                    tags: [
                        "KONNECT PREMIUM",
                        "ENTERPRISE"
                    ]
                },
                {
                    name: "AI Request Transformer",
                    description: "Use an LLM service to inspect and transform the client's request body prior to proxying the request to the upstream server",
                    image: AiRequestTransformerImg,
                    slug: "ai-request-transformer",
                    tags: [
                        "OSS"
                    ]
                },
                {
                    name: "AI Response Transformer",
                    description: "Use an LLM service to examine the upstream HTTP(S) prior to forwarding it to the client",
                    image: AiResponseTransformerImg,
                    slug: "ai-response-transformer",
                    tags: [
                        "OSS"
                    ]
                }
            ]
        },
        {
            category: "Analytics & Monitoring",
            plugins: [
                {
                    name: "AppDynamics",
                    description: "Integrate Kong with the AppDynamics APM Platform",
                    image: AppDynamicsImg,
                    slug: "app-dynamics",
                    tags: [
                        "KONNECT PAID",
                        "ENTERPRISE"
                    ]
                },
                {
                    name: "Datadog",
                    description: "Visualize metrics on Datadog",
                    image: DatadogImg,
                    slug: "datadog",
                    tags: [
                        "OSS"
                    ]
                },
                {
                    name: "OpenTelemetry",
                    description: "Propagate spans and report space to a backend server through OTLP protocol.",
                    image: OpentelemetryImg,
                    slug: "opentelemetry",
                    tags: [
                        "OSS"
                    ]
                },
                {
                    name: "Prometheus",
                    description: "Expose metrics related to Kong and proxied upstream services in Prometheus exposition format",
                    image: PrometheusImg,
                    slug: "prometheus",
                    tags: [
                        "OSS"
                    ]
                },
                {
                    name: "StatsD",
                    description: "Send metrics to StatsD",
                    image: StatsdImg,
                    slug: "statsd",
                    tags: [
                        "OSS"
                    ]
                },
                {
                    name: "StatsD Advanced",
                    description: "(Deprecated) Send metrics to StatsD with more flexible options",
                    image: StatsdAdvancedImg,
                    slug: "statsd-advanced",
                    tags: [
                        "KONNECT PAID",
                        "ENTERPRISE"
                    ]
                },
                {
                    name: "Zipkin",
                    description: "Propagate Zipkin spans and report space to a Zipkin server",
                    image: ZipkinImg,
                    slug: "zipkin",
                    tags: [
                        "OSS"
                    ]
                }
            ]
        },
        {
            category: "Authentication",
            plugins: [
                {
                    name: "Basic Authentication",
                    description: "Add Basic Authentication to your services",
                    image: BasicAuthImg,
                    slug: "basic-auth",
                    tags: [
                        "OSS"
                    ]
                },
                {
                    name: "HMAC Auth",
                    description: "Add HMAC Authentication to your services",
                    image: HmacAuthImg,
                    slug: "hmac-auth",
                    tags: [
                        "OSS"
                    ]
                },
                {
                    name: "JWE Decrypt",
                    description: "Decrypt a JWE token in a request",
                    image: JweDecryptImg,
                    slug: "jwe-decrypt",
                    tags: [
                        "KONNECT PAID",
                        "ENTERPRISE"
                    ]
                },
                {
                    name: "JWT",
                    description: "Verify and authenticate JSON Web Tokens",
                    image: JwtImg,
                    slug: "jwt",
                    tags: [
                        "OSS"
                    ]
                },
                {
                    name: "Key Auth",
                    description: "Add key authentication to your Services",
                    image: KeyAuthImg,
                    slug: "key-auth",
                    tags: [
                        "OSS"
                    ]
                },
                {
                    name: "Key Authentication - Encrypted",
                    description: "Add key authentication to your services",
                    image: KeyAuthEncImg,
                    slug: "key-auth-enc",
                    tags: [
                        "ENTERPRISE"
                    ]
                },
                {
                    name: "Kong JWT Signer",
                    description: "Verify and sign one or two tokens in a request",
                    image: JwtSignerImg,
                    slug: "jwt-signer",
                    tags: [
                        "ENTERPRISE"
                    ]
                },
                {
                    name: "LDAP Authentication",
                    description: "Integrate Kong with an LDAP server",
                    image: LdapAuthImg,
                    slug: "ldap-auth",
                    tags: [
                        "OSS"
                    ]
                },
                {
                    name: "LDAP Authentication Advanced",
                    description: "Secure Kong with username and password protection, use LDAP search and service directory mapping",
                    image: LdapAuthAdvancedImg,
                    slug: "ldap-auth-advanced",
                    tags: [
                        "KONNECT PAID",
                        "ENTERPRISE"
                    ]
                },
                {
                    name: "Mutual TLS Authentication",
                    description: "Secure routes and services with client certificate and mutual TLS authentication",
                    image: MtlsAuthImg,
                    slug: "mtls-auth",
                    tags: [
                        "KONNECT PAID",
                        "ENTERPRISE"
                    ]
                },
                {
                    name: "OAuth 2.0 Authentication",
                    description: "Add OAuth 2.0 authentication to your service",
                    image: Oauth2Img,
                    slug: "oauth2",
                    tags: [
                        "OSS"
                    ]
                },
                {
                    name: "OAuth 2.0 Introspection",
                    description: "Integrate Kong with a third-party OAuth 2.0 Authorization Server",
                    image: Oauth2IntrospectionImg,
                    slug: "oauth2-introspection",
                    tags: [
                        "KONNECT PAID",
                        "ENTERPRISE"
                    ]
                },
                {
                    name: "OpenID Connect",
                    description: "Integrate Kong with a third-party OpenID Connect provider",
                    image: OpenidConnectImg,
                    slug: "openid-connect",
                    tags: [
                        "KONNECT PREMIUM",
                        "ENTERPRISE"
                    ]
                },
                {
                    name: "Portal Application Registration",
                    description: "Allow portal developers to register applications against services",
                    image: ApplicationRegistrationImg,
                    slug: "application-registration",
                    tags: [
                        "ENTERPRISE"
                    ]
                },
                {
                    name: "SAML",
                    description: "Provides SAML v2.0 authentication and authorization between a service provider (Kong) and an identity provider (IdP)",
                    image: SamlImg,
                    slug: "saml",
                    tags: [
                        "KONNECT PAID",
                        "ENTERPRISE"
                    ]
                },
                {
                    name: "Session",
                    description: "Support sessions for Kong authentication plugins.",
                    image: SessionImg,
                    slug: "session",
                    tags: [
                        "OSS"
                    ]
                },
                {
                    name: "Vault Authentication",
                    description: "Add Vault authentication to your services",
                    image: VaultAuthImg,
                    slug: "vault-auth",
                    tags: [
                        "ENTERPRISE"
                    ]
                },
                {
                    name: "Okta",
                    description: "Integrate Okta's API Access Management (OAuth as a Service) with Kong API Gateway",
                    image: OktaImg,
                    slug: "okta",
                    tags: [
                        "ENTERPRISE",
                        "techpartner"
                    ]
                }
            ]
        },
        {
            category: "Logging",
            plugins: [
                {
                    name: "File Log",
                    description: "Append request and response data to a log file",
                    image: FileLogImg,
                    slug: "file-log",
                    tags: [
                        "OSS"
                    ]
                },
                {
                    name: "HTTP Log",
                    description: "Send request and response logs to an HTTP server",
                    image: HttpLogImg,
                    slug: "http-log",
                    tags: [
                        "OSS"
                    ]
                },
                {
                    name: "Kafka Log",
                    description: "Publish logs to a Kafka topic",
                    image: KafkaLogImg,
                    slug: "kafka-log",
                    tags: [
                        "KONNECT PAID",
                        "ENTERPRISE"
                    ]
                },
                {
                    name: "Loggly",
                    description: "Send request and response logs to Loggly",
                    image: LogglyImg,
                    slug: "loggly",
                    tags: [
                        "OSS"
                    ]
                },
                {
                    name: "Syslog",
                    description: "Send request and response logs to Syslog",
                    image: SyslogImg,
                    slug: "syslog",
                    tags: [
                        "OSS"
                    ]
                },
                {
                    name: "TCP Log",
                    description: "Send request and response logs to a TCP server",
                    image: TcpLogImg,
                    slug: "tcp-log",
                    tags: [
                        "OSS"
                    ]
                },
                {
                    name: "UDP Log",
                    description: "Send request and response logs to a UDP server",
                    image: UdpLogImg,
                    slug: "udp-log",
                    tags: [
                        "OSS"
                    ]
                }
            ]
        },
        {
            category: "Security",
            plugins: [
                {
                    name: "ACME",
                    description: "Let's Encrypt and ACMEv2 integration with Kong Gateway",
                    image: AcmeImg,
                    slug: "acme",
                    tags: [
                        "OSS"
                    ]
                },
                {
                    name: "Bot Detection",
                    description: "Detect and block bots or custom clients",
                    image: BotDetectionImg,
                    slug: "bot-detection",
                    tags: [
                        "OSS"
                    ]
                },
                {
                    name: "CORS",
                    description: "Allow developers to make requests from the browser",
                    image: CorsImg,
                    slug: "cors",
                    tags: [
                        "OSS"
                    ]
                },
                {
                    name: "IP Restriction",
                    description: "Allow or deny IPs that can make requests to your services",
                    image: IpRestrictionImg,
                    slug: "ip-restriction",
                    tags: [
                        "OSS"
                    ]
                },
                {
                    name: "OPA",
                    description: "Authorize requests against Open Policy Agent",
                    image: OpaImg,
                    slug: "opa",
                    tags: [
                        "KONNECT PAID",
                        "ENTERPRISE"
                    ]
                },
                {
                    name: "TLS Handshake Modifier",
                    description: "Requests a client to present its client certificate",
                    image: TlsHandshakeModifierImg,
                    slug: "tls-handshake-modifier",
                    tags: [
                        "ENTERPRISE"
                    ]
                },
                {
                    name: "TLS Metadata Headers",
                    description: "Proxies TLS client certificate metadata to upstream services via HTTP headers",
                    image: TlsMetadataHeadersImg,
                    slug: "tls-metadata-headers",
                    tags: [
                        "ENTERPRISE"
                    ]
                },
                {
                    name: "Imperva API Security",
                    description: "Integrate Kong Gateway with Imperva API Security to discover, monitor, and protect APIs",
                    image: ImpAppsecConnectorImg,
                    slug: "imp-appsec-connector",
                    tags: [
                        "ENTERPRISE",
                        "techpartner"
                    ]
                }
            ]
        },
        {
            category: "Serverless",
            plugins: [
                {
                    name: "AWS Lambda",
                    description: "Invoke and manage AWS Lambda functions from Kong",
                    image: AwsLambdaImg,
                    slug: "aws-lambda",
                    tags: [
                        "OSS"
                    ]
                },
                {
                    name: "Apache OpenWhisk",
                    description: "Invoke and manage OpenWhisk actions from Kong",
                    image: OpenwhiskImg,
                    slug: "openwhisk",
                    tags: [
                        "OSS"
                    ]
                },
                {
                    name: "Azure Functions",
                    description: "Invoke and manage Azure functions from Kong",
                    image: AzureFunctionsImg,
                    slug: "azure-functions",
                    tags: [
                        "OSS"
                    ]
                },
                {
                    name: "Kong Functions (Post-Plugin)",
                    description: "Add and manage custom Lua functions to run after other plugins",
                    image: PostFunctionImg,
                    slug: "post-function",
                    tags: [
                        "OSS"
                    ]
                },
                {
                    name: "Kong Functions (Pre-Plugins)",
                    description: "Add and manage custom Lua functions to run before other plugins",
                    image: PreFunctionImg,
                    slug: "pre-function",
                    tags: [
                        "OSS"
                    ]
                }
            ]
        },
        {
            category: "Traffic Control",
            plugins: [
                {
                    name: "ACL",
                    description: "Control which consumers can access services",
                    image: AclImg,
                    slug: "acl",
                    tags: [
                        "OSS"
                    ]
                },
                {
                    name: "Canary Release",
                    description: "Slowly roll out software changes to a subset of users",
                    image: CanaryImg,
                    slug: "canary",
                    tags: [
                        "KONNECT PREMIUM",
                        "ENTERPRISE"
                    ]
                },
                {
                    name: "Forward Proxy Advanced",
                    description: "Allows Kong to connect to intermediary transparent HTTP proxies",
                    image: ForwardProxyImg,
                    slug: "forward-proxy",
                    tags: [
                        "KONNECT PREMIUM",
                        "ENTERPRISE"
                    ]
                },
                {
                    name: "GraphQL Proxy Caching Advanced",
                    description: "Cache and serve commonly requested responses in Kong",
                    image: GraphqlProxyCacheAdvancedImg,
                    slug: "graphql-proxy-cache-advanced",
                    tags: [
                        "KONNECT PAID",
                        "ENTERPRISE"
                    ]
                },
                {
                    name: "GraphQL Rate Limiting Advanced",
                    description: "Provide rate limiting for GraphQL queries",
                    image: GraphqlRateLimitingAdvancedImg,
                    slug: "graphql-rate-limiting-advanced",
                    tags: [
                        "KONNECT PREMIUM",
                        "ENTERPRISE"
                    ]
                },
                {
                    name: "Mocking",
                    description: "Provide mock endpoints to test your APIs against your services",
                    image: MockingImg,
                    slug: "mocking",
                    tags: [
                        "KONNECT PAID",
                        "ENTERPRISE"
                    ]
                },
                {
                    name: "OAS Validation",
                    description: "Validate HTTP requests and responses based on an OpenAPI 3.0 or Swagger API Specification",
                    image: OasValidationImg,
                    slug: "oas-validation",
                    tags: [
                        "KONNECT PAID",
                        "ENTERPRISE"
                    ]
                },
                {
                    name: "Proxy Cache",
                    description: "Cache and serve commonly requested responses in Kong",
                    image: ProxyCacheImg,
                    slug: "proxy-cache",
                    tags: [
                        "OSS"
                    ]
                },
                {
                    name: "Proxy Caching Advanced",
                    description: "Cache and serve commonly requested responses in Kong",
                    image: ProxyCacheAdvancedImg,
                    slug: "proxy-cache-advanced",
                    tags: [
                        "KONNECT PAID",
                        "ENTERPRISE"
                    ]
                },
                {
                    name: "Rate Limiting",
                    description: "Rate limit how many HTTP requests can be made in a period of time",
                    image: RateLimitingImg,
                    slug: "rate-limiting",
                    tags: [
                        "OSS"
                    ]
                },
                {
                    name: "Rate Limiting Advanced",
                    description: "Upgrades Kong Rate Limiting with more flexibility and higher performance",
                    image: RateLimitingAdvancedImg,
                    slug: "rate-limiting-advanced",
                    tags: [
                        "KONNECT PREMIUM",
                        "ENTERPRISE"
                    ]
                },
                {
                    name: "Request Size Limiting",
                    description: "Block requests with bodies greater than a specified size",
                    image: RequestSizeLimitingImg,
                    slug: "request-size-limiting",
                    tags: [
                        "OSS"
                    ]
                },
                {
                    name: "Request Termination",
                    description: "Terminates all requests with a specific response",
                    image: RequestTerminationImg,
                    slug: "request-termination",
                    tags: [
                        "OSS"
                    ]
                },
                {
                    name: "Request Validator",
                    description: "Validates requests before they reach the upstream service",
                    image: RequestValidatorImg,
                    slug: "request-validator",
                    tags: [
                        "KONNECT PAID",
                        "ENTERPRISE"
                    ]
                },
                {
                    name: "Response Rate Limiting",
                    description: "Rate limit based on a custom response header value",
                    image: ResponseRatelimitingImg,
                    slug: "response-ratelimiting",
                    tags: [
                        "OSS"
                    ]
                },
                {
                    name: "Route By Header",
                    description: "Route request based on request headers",
                    image: RouteByHeaderImg,
                    slug: "route-by-header",
                    tags: [
                        "KONNECT PAID",
                        "ENTERPRISE"
                    ]
                },
                {
                    name: "Upstream Timeout",
                    description: "Set timeouts on routes and override service-level timeouts",
                    image: UpstreamTimeoutImg,
                    slug: "upstream-timeout",
                    tags: [
                        "KONNECT PREMIUM",
                        "ENTERPRISE"
                    ]
                },
                {
                    name: "WebSocket Size Limit",
                    description: "Block incoming WebSocket messages greater than a specified size",
                    image: WebsocketSizeLimitImg,
                    slug: "websocket-size-limit",
                    tags: [
                        "KONNECT PAID",
                        "ENTERPRISE"
                    ]
                },
                {
                    name: "WebSocket Validator",
                    description: "Validate WebSocket messages before they are proxied",
                    image: WebsocketValidatorImg,
                    slug: "websocket-validator",
                    tags: [
                        "KONNECT PAID",
                        "ENTERPRISE"
                    ]
                },
                {
                    name: "XML Threat Protection",
                    description: "Apply structural and size checks on XML payloads",
                    image: XmlThreatProtectionImg,
                    slug: "xml-threat-protection",
                    tags: [
                        "KONNECT PREMIUM",
                        "ENTERPRISE"
                    ]
                }
            ]
        },
        {
            category: "Transformations",
            plugins: [
                {
                    name: "Correlation ID",
                    description: "Correlate requests and responses using a unique ID",
                    image: CorrelationIdImg,
                    slug: "correlation-id",
                    tags: [
                        "OSS"
                    ]
                },
                {
                    name: "DeGraphQL",
                    description: "Transform a GraphQL upstream into a REST API",
                    image: DegraphqlImg,
                    slug: "degraphql",
                    tags: [
                        "KONNECT PREMIUM",
                        "ENTERPRISE"
                    ]
                },
                {
                    name: "Exit Transformer",
                    description: "Customize Kong exit responses sent downstream",
                    image: ExitTransformerImg,
                    slug: "exit-transformer",
                    tags: [
                        "KONNECT PAID",
                        "ENTERPRISE"
                    ]
                },
                {
                    name: "Kafka Upstream",
                    description: "Transform requests into Kafka messages in a Kafka topic.",
                    image: KafkaUpstreamImg,
                    slug: "kafka-upstream",
                    tags: [
                        "KONNECT PAID",
                        "ENTERPRISE"
                    ]
                },
                {
                    name: "Request Transformer",
                    description: "Use regular expressions, variables, and templates to transform requests",
                    image: RequestTransformerImg,
                    slug: "request-transformer",
                    tags: [
                        "OSS"
                    ]
                },
                {
                    name: "Request Transformer Advanced",
                    description: "Use powerful regular expressions, variables, and templates to transform API requests",
                    image: RequestTransformerAdvancedImg,
                    slug: "request-transformer-advanced",
                    tags: [
                        "KONNECT PREMIUM",
                        "ENTERPRISE"
                    ]
                },
                {
                    name: "Response Transformer",
                    description: "Modify the upstream response before returning it to the client",
                    image: ResponseTransformerImg,
                    slug: "response-transformer",
                    tags: [
                        "OSS"
                    ]
                },
                {
                    name: "Response Transformer Advanced",
                    description: "Modify the upstream response before returning it to the client, with greater customization capabilities",
                    image: ResponseTransformerAdvancedImg,
                    slug: "response-transformer-advanced",
                    tags: [
                        "KONNECT PREMIUM",
                        "ENTERPRISE"
                    ]
                },
                {
                    name: "Route Transformer Advanced",
                    description: "Transform routing by changing the upstream server, port, or path",
                    image: RouteTransformerAdvancedImg,
                    slug: "route-transformer-advanced",
                    tags: [
                        "KONNECT PREMIUM",
                        "ENTERPRISE"
                    ]
                },
                {
                    name: "gRPC-Web",
                    description: "Allow browser clients to call gRPC services",
                    image: GrpcWebImg,
                    slug: "grpc-web",
                    tags: [
                        "OSS"
                    ]
                },
                {
                    name: "gRPC-gateway",
                    description: "Access gRPC services through HTTP REST",
                    image: GrpcGatewayImg,
                    slug: "grpc-gateway",
                    tags: [
                        "OSS"
                    ]
                },
                {
                    name: "jq",
                    description: "Transform JSON objects included in API requests or responses using jq programs.",
                    image: JqImg,
                    slug: "jq",
                    tags: [
                        "KONNECT PREMIUM",
                        "ENTERPRISE"
                    ]
                }
            ]
        }
    ]
};
